/**
 * Ритуал захвата пустой соты (§Т2.2).
 */

import type { MapHexCard } from "@hive/shared/api/map";

import { apiFetch } from "./client.js";

export async function performRitual(
  hexId: string,
  traceId: number,
  token: string,
  idempotencyKey: string,
): Promise<MapHexCard> {
  return apiFetch<MapHexCard>(`/map/hex/${encodeURIComponent(hexId)}/ritual`, {
    method: "POST",
    token,
    headers: { "Idempotency-Key": idempotencyKey },
    body: JSON.stringify({ traceId }),
  });
}
